import {createContext} from 'react'

const istavrityContext = createContext();

export default istavrityContext;